/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from '../utils/history';
import Chargecard from './landingpageReducers';
import auth from './signup';
import Header from './header';
import Snackbar from './snackbar';
import users from './usersReducer';
import expense from './expenseReducers';
import bank from './bankReducer';
import expenseDetails from './expenseDetailsReducers';
import Loader from './loaderReducer';
import Filter from './filterTypeReducer';
import FilterField from './filterFieldReducer';
import FilterSearch from './filterSearchReducer';
import SaveFilter from './filterSaveReducer';
import Address from './addressReducer';
import Kyc from './kycReducer';
import Bill from './billReducer';
import Emandate from './emandateReducer';
import EMandateModify from './eMandateModifyReducer';
import LoginReducer from './loginReducer';
import Vendor from "./vendorReducer";
import Invoice from "./invoiceReducer";
import BulkVendorReducer from "./bulkVendorReducer";
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer() {
  const rootReducer = combineReducers({
    router: connectRouter(history),
    Chargecard,
    auth,
    Header,
    Snackbar,
    users,
    expense,
    bank,
    expenseDetails,
    Loader,
    Filter,
    FilterField,
    FilterSearch,
    SaveFilter,
    Address,
    Kyc,
    Bill,
    Emandate,
    EMandateModify,
    LoginReducer,
    Vendor,
    Invoice,
    BulkVendorReducer
  });

  return rootReducer;
}
